class InterviewList {
  constructor(selector) {
    this.root = document.querySelector(selector);
    if (!this.root || typeof Swiper === 'undefined') return;

    this.sliderEl = this.root.querySelector('.js-interviewListSlider');
    if (!this.sliderEl) return;

    this.mq = window.matchMedia('(max-width: 767px)');
    this.originalSliderHtml = this.sliderEl.innerHTML;
    this.slideCount = this.sliderEl.querySelectorAll('.swiper-slide').length;
    if (this.slideCount === 0) return;

    this.spaceBetweenDesktop = 40;
    this.spaceBetweenMobile = 24;
    this.resizeTimer = null;
    this.lastWidth = window.innerWidth;
    this.swiper = null;

    this.initSwiper();
    this.bindResize();
    this.mq.addEventListener('change', () => {
      this.reinitSwiper();
    });
  }

  refreshSlides() {
    this.slides = this.sliderEl.querySelectorAll('.swiper-slide');
  }

  isMobile() {
    return this.mq.matches;
  }

  getSpaceBetween() {
    return this.isMobile()
      ? this.spaceBetweenMobile
      : this.spaceBetweenDesktop;
  }

  getVisibleSlideCount() {
    const slideWidth = this.slides[0].offsetWidth;
    if (!slideWidth) return 1;

    const containerWidth = this.sliderEl.offsetWidth || window.innerWidth;
    return Math.max(1, Math.ceil(containerWidth / (slideWidth + this.getSpaceBetween())));
  }

  shouldEnableLoop() {
    return this.slideCount > this.getVisibleSlideCount();
  }

  getSwiperOptions(enableLoop) {
    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      centeredSlidesBounds: !enableLoop,
      spaceBetween: this.spaceBetweenMobile,
      speed: 600,
      watchSlidesProgress: false,
      roundLengths: true,
      updateOnWindowResize: false,
      observer: false,
      observeParents: false,
      loop: enableLoop,
      loopedSlides: enableLoop ? this.slideCount : undefined,
      allowTouchMove: this.slideCount > 1,
      breakpoints: {
        768: {
          centeredSlides: false,
          centeredSlidesBounds: false,
          spaceBetween: this.spaceBetweenDesktop,
          watchSlidesProgress: true,
          updateOnWindowResize: true,
        },
      },
    };
  }

  initSwiper(activeIndex = 0) {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this.sliderEl.innerHTML = this.originalSliderHtml;
    this.refreshSlides();

    const enableLoop = this.shouldEnableLoop();

    this.swiper = new Swiper(this.sliderEl, this.getSwiperOptions(enableLoop));

    if (enableLoop && activeIndex > 0) {
      this.swiper.slideToLoop(activeIndex, 0, false);
    } else if (!enableLoop && activeIndex > 0) {
      this.swiper.slideTo(activeIndex, 0, false);
    }
  }

  reinitSwiper() {
    const activeIndex = this.swiper
      ? (this.swiper.params.loop ? this.swiper.realIndex : this.swiper.activeIndex)
      : 0;
    this.initSwiper(activeIndex);
  }

  bindResize() {
    window.addEventListener('resize', () => {
      if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        if (!this.swiper) return;

        const width = window.innerWidth;
        if (width === this.lastWidth) return;

        const crossedBreakpoint =
          (this.lastWidth < 768 && width >= 768) ||
          (this.lastWidth >= 768 && width < 768);

        this.lastWidth = width;

        if (crossedBreakpoint) {
          this.reinitSwiper();
          return;
        }

        if (this.isMobile()) {
          this.swiper.update();
          return;
        }

        this.reinitSwiper();
      }, 200);
    });
  }
}
